import * as React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import jwtDecode from 'jwt-decode';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import TableFooter from '@mui/material/TableFooter';
import { useSelector } from 'react-redux';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Autocomplete from '@mui/material/Autocomplete';
import Snackbar from '@mui/material/Snackbar';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CloseIcon from '@mui/icons-material/Close';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import CancelIcon from '@mui/icons-material/Cancel';
import UploadIcon from '@mui/icons-material/Upload';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import addCommas from '../../utils/functions/commas';
import NotiAlert from '../../components/NotiAlert/NotiAlert';
import { useGetGroupBankAllQuery } from '../../services/groupBank';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Link, Table, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';

function WaitingUploadPayment({
  setOpenDialogPaymentWaiting,
  openDialogPaymentWaiting,
  dataRowDetail,
  refetchMain,
}) {
  const feeRef = React.useRef(null);
  const paymentAmountRef = React.useRef(null);
  const { t } = useTranslation();
  const [note, setNote] = useState('');
  const [bankData, setBankData] = useState([]);
  const { data: bankAll } = useGetGroupBankAllQuery();
  const [importFile, setImportFile] = useState([]);
  const [paymentAmout, setPaymentAmout] = useState('');
  const [importFileWHT, setImportFileWHT] = useState([]);
  const [dateValue, setDateValue] = useState(dayjs());
  const [dataRowDetailShow, setDataRowDetailShow] = useState([]);
  console.log("🚀 ~ WaitingUploadPayment ~ dataRowDetailShow:", dataRowDetailShow)
  const [customerName, setCustomerName] = useState('');
  const [selectBank, setSelectBank] = useState('');
  const [openAlert, setOpenAlert] = useState(false);
  const [openFailAlert, setOpenFailAlert] = useState(false);
  const [errorValue, setErrorValue] = useState('');
  const [snackBarLoading, setSnackbarLoading] = useState(false);
  const [customerCode, setCustomerCode] = useState('');
  const [sorgcode, setSorgcode] = useState('');
  const [whtRate, setWhtRate] = useState(false);
  const [fee, setFee] = useState('');
  const [hasError, setHasError] = useState(false);
  const [datafederalTaxId, setDataFederalTaxId] = useState('');
  const { federalTaxId } = useSelector((state) => state.custNO);
  const token = localStorage.getItem('token');
  const isAdmin = token ? jwtDecode(token).ROLE !== 'USER' : false;
  const [valueAlert, setValueAlert] = useState('');
  const [totalAmount, setTotalAmount] = useState(
    dataRowDetail.total_pay_amount,
  );

  const resetUploadForm = () => {
    setNote('');
    setImportFile([]);
    setImportFileWHT([]);
    setPaymentAmout('');
    setDateValue(dayjs());
    setSelectBank('');
    setFee('');
    setHasError(false);
    setSnackbarLoading(false);
    setTotalAmount(dataRowDetail?.total_pay_amount || 0);
  };

  useEffect(() => {
    if (Array.isArray(dataRowDetailShow) && dataRowDetailShow.length > 0) {
      setCustomerName(dataRowDetailShow[0]?.customer?.customer_name);
    } else {
      setCustomerName('');
    }
  }, [dataRowDetailShow]);

  const handleChangeFee = (event) => {
    const feeValue = event.target.value;
    setFee(feeValue);

    // ตรวจสอบว่า feeValue เป็นค่าที่สามารถแปลงเป็นตัวเลขได้
    const feeAmount = parseFloat(feeValue);
    if (!isNaN(feeAmount)) {
      setTotalAmount(dataRowDetail.total_pay_amount - feeAmount); // ลบ fee จาก total_pay_amount
    } else {
      setTotalAmount(dataRowDetail.total_pay_amount); // ถ้าไม่มีการกรอกค่าหรือกรอกไม่ถูกต้อง ให้ใช้ total_pay_amount เดิม
    }
  };

  useEffect(() => {
    if (dataRowDetail?.total_pay_amount !== undefined) {
      setTotalAmount(dataRowDetail.total_pay_amount);
    }
  }, [dataRowDetail]);

  useEffect(() => {
    setBankData(bankAll?.banks || []);
  }, [bankAll]);

  useEffect(() => {
    setWhtRate(dataRowDetail.wht_rate);
    setDataFederalTaxId(federalTaxId);
  }, [dataRowDetail, federalTaxId]);


  const formatBankOptionLabel = (option = {}) => option?.bank_fullname || '';

  const normalizeBankSearchText = (value = '') =>
    String(value).toLowerCase().replace(/[-\s]/g, '');

  const selectedBankOption =
    bankData.find((option) => option?.bank_code === selectBank) || null;

  const handleCloseDialogUpload = () => {
    setOpenAlert(false);
    setOpenFailAlert(false);

    // setOpenDialogSlip(false);
  };

  const formatFileSize = (size) => {
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
    return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  };

  const handleDeleteWHT = (fileWHTDelete) => () => {
    setImportFileWHT((fileWHT) =>
      fileWHT.filter((fileWHT) => fileWHT.name !== fileWHTDelete.name),
    );
  };

  const handleDelete = (fileDelete) => () => {
    setImportFile((file) =>
      file.filter((file) => file.name !== fileDelete.name),
    );
  };

  useEffect(() => {
    setDataRowDetailShow(dataRowDetail.result);
    setCustomerCode(dataRowDetail.customer_code);
    setSorgcode(dataRowDetail.sorgcode);
  }, [dataRowDetail]);

  const handleChangePaymentAmount = (event) => {
    setPaymentAmout(event.target.value);
  };

  // ------------------ [แก้ไข] เพิ่มการกรองไฟล์ในฟังก์ชันนี้ ------------------
  const handleFileUpload = (event) => {
    const { files } = event.target;
    const folderFiles = Array.from(files);

    // กรองเฉพาะไฟล์ที่เป็น PDF หรือ รูปภาพ
    const validFiles = folderFiles.filter(
      (file) =>
        file.type === 'application/pdf' || file.type.startsWith('image/'),
    );

    // ถ้ามีไฟล์ที่ไม่ผ่านเงื่อนไข ให้แจ้งเตือน (Optional)
    if (validFiles.length < folderFiles.length) {
      setErrorValue('รองรับเฉพาะไฟล์รูปภาพและ PDF เท่านั้น');
      setOpenFailAlert(true);
    }

    setImportFile((prevFiles) => [...prevFiles, ...validFiles]);
    event.target.value = null; // Reset input
  };

  // ------------------ [แก้ไข] เพิ่มการกรองไฟล์ในฟังก์ชันนี้ ------------------
  const handleFileUploadWHT = (event) => {
    const { files } = event.target;
    const folderFiles = Array.from(files);

    // กรองเฉพาะไฟล์ที่เป็น PDF หรือ รูปภาพ
    const validFiles = folderFiles.filter(
      (file) =>
        file.type === 'application/pdf' || file.type.startsWith('image/'),
    );

    if (validFiles.length < folderFiles.length) {
      setErrorValue('รองรับเฉพาะไฟล์รูปภาพและ PDF เท่านั้น');
      setOpenFailAlert(true);
    }

    setImportFileWHT((prevFiles) => [...prevFiles, ...validFiles]);
    event.target.value = null; // Reset input
  };

  const handleChangeNote = (e) => {
    setNote(e.target.value);
  };

  const apiUrl = isAdmin
    ? process.env.REACT_APP_API_URL_admin
    : process.env.REACT_APP_API_URL;

  const renderPaymentType = (type) => {
    let color;
    let text;

    switch (type) {
      case 'Post-Paid':
        color = '#0288D1';
        text = t('app.postPaid');
        break;
      case 'prepaid':
        color = '#01579B';
        text = t('app.prePaid');
        break;
      default:
        color = 'inherit';
        text = type;
    }

    return <span style={{ color: color }}>{text}</span>;
  };

  const sendUploadSlip = async () => {
    setSnackbarLoading(true);

    try {
      const formData = new FormData();
      const orderIDref = dataRowDetail.order_id_ref;

      formData.append('orderIdRef', orderIDref);
      formData.append('transferAmount', parseFloat(paymentAmout));
      formData.append('transferBank', selectBank);
      formData.append('transferDate', dateValue);
      formData.append('remark', note);
      formData.append('totalFee', parseFloat(fee));

      importFileWHT.forEach((file) => {
        formData.append('whtEvidence', file);
      });

      importFile.forEach((file) => {
        formData.append('paymentEvidence', file);
      });

      const response = await axios.post(
        `${apiUrl}/payment-transaction/upload/orderid?customerCode=${customerCode}&sorgcode=${sorgcode}&federalTaxId=${datafederalTaxId}&customerName=${customerName}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );
      if (response.data.message == 'OK') {
        resetUploadForm();
        setOpenAlert(true);
        setOpenDialogPaymentWaiting(false);
        refetchMain();
      }
    } catch (error) {
      const messageError = error.response.data.error.message;
      if (messageError === 'Error: PAYMENT EVIDENCE IS REQUIRED') {
        setErrorValue('กรุณาอัพโหลดหลักฐานการชำระเงิน');
      } else if (messageError === 'File too large') {
        setErrorValue('ไฟล์มีขนาดใหญ่เกินไป');
      } else if (messageError === 'Error: WHT EVIDENCE IS REQUIRED') {
        setErrorValue('กรุณาอัพโหลดหลักฐานหัก ภาษี ณ ที่จ่าย');
      }

      setOpenFailAlert(true);
      setSnackbarLoading(false);
      console.error(
        'Error:',
        error.response ? error.response.data : error.message,
      );
    }
  };

  const onClickUpload = () => {
    if (paymentAmout === '' || selectBank?.length === 0 || fee === '') {
      setHasError(true);
      setErrorValue('กรุณากรอกข้อมูลให้ครบถ้วน');

      if (fee === '') {
        feeRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (paymentAmout === '') {
        paymentAmountRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
      return;
    }

    const enteredPaymentAmount = Number.parseFloat(paymentAmout);
    const expectedPaymentAmount = Number(totalAmount);
    if (
      !Number.isFinite(enteredPaymentAmount)
      || !Number.isFinite(expectedPaymentAmount)
      || enteredPaymentAmount.toFixed(2) !== expectedPaymentAmount.toFixed(2)
    ) {
      setHasError(true);
      setErrorValue(t('app.amountMismatch'));
      return;
    }

    // หากผ่านทุกเงื่อนไข เรียก API เพื่ออัปโหลด
    setHasError(false);
    sendUploadSlip();
  };

  const handleClose = () => {
    resetUploadForm();
    setOpenDialogPaymentWaiting(false);
  };

  const customCellHeader = {
    whiteSpace: 'nowrap',
    backgroundColor: 'primary.main',
    color: 'white',
    padding: '14px',
  };

  const customCellData = {
    fontSize: '12px',
    padding: '2px',
  };

  const customCellInvAndSo = {
    fontSize: '12px',
    padding: '2px',
    fontFamily: 'Monospace',
  };

  const parseDate = (str) => {
    // "20251001" -> "2025-10-01"
    const year = str.slice(0, 4);
    const month = str.slice(4, 6);
    const day = str.slice(6, 8);
    return new Date(`${year}-${month}-${day}`);
  };

  return (
    <>
      <Dialog
        open={openDialogPaymentWaiting}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            handleClose(event, reason);
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          '& .MuiDialog-paper': {
            width: '100%',
            maxWidth: '100%',
            height: '100%',
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          <div className="flex justify-between">
            <div className="hidden lg:block text-green-600 ml-5 font-bold ">
              {' '}
              {t('app.pendingPayments')}/{t('app.uploadSlip')}
            </div>
            <div className="lg:hidden text-green-600  font-bold ">
              {' '}
              {t('app.pendingPayments')}/{t('app.uploadSlip')}
            </div>

            <div>
              <button>
                <CloseIcon onClick={handleClose} />
              </button>
            </div>
          </div>
        </DialogTitle>

        <DialogContent>
          <div className="flex flex-col lg:flex-row justify-between lg:h-full">
            <div className="w-full lg:flex-[2] lg:pr-4 overflow-y-auto">
              <div className=" md:border-2">
                <TableContainer sx={{ maxHeight: 350 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.invoiceNo')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.period')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.saleOrder')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.serviceName')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.startDate')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.endDate')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.paymentType')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.totalAmount')}
                        </TableCell>

                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.wht')}
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    {_.size(dataRowDetailShow) ? (
                      <TableBody>
                        {dataRowDetailShow
                          .slice()
                          .sort(
                            (a, b) =>
                              parseDate(a.period_start_date) -
                              parseDate(b.period_start_date),
                          )
                          .map((row, index) => (
                            <TableRow
                              key={index}
                              sx={{
                                '&:last-child td, &:last-child th': {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell
                                align="center"
                                sx={customCellInvAndSo}
                              >
                                {row.invoice_no}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                {row.period_periodList}
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={customCellInvAndSo}
                              >
                                {row.so_number}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                {row.materials[0].material_name}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                {dayjs(row.period_start_date).format(
                                  'DD MMM YYYY',
                                )}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                {dayjs(row.period_end_date).format(
                                  'DD MMM YYYY',
                                )}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                {renderPaymentType(row.payment_type)}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                {addCommas(row.amount)}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                <Checkbox checked={row.wht_selected} readOnly />
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    ) : (
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={10} align="center">
                            <div>ไม่มีข้อมูล</div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}

                    <TableFooter className="bg-gray-200 sticky bottom-0 border-t-2 border-gray-600 ">
                      <TableRow>
                        <TableCell colSpan={6} />
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                          {t('app.totalAmount')}
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                          {addCommas(dataRowDetail.total_amount)}
                        </TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableFooter>
                  </Table>
                </TableContainer>
              </div>
              <div className=" mt-5   border-2 border-gray-900 w-[100%] h-[100px] rounded-md border-dashed bg-gray-100">
                <div className="ml-2 mt-2">
                  <div> {t('app.remark')} </div>
                  <textarea
                    className="w-full h-[60px] border-none focus:outline-none bg-gray-100 resize-none"
                    onChange={handleChangeNote}
                    value={note}
                    label
                  />
                </div>
              </div>
            </div>

            {/* กล่องขวา */}

            <div className="w-full lg:flex-[1] flex flex-col mt-8 lg:mt-0 lg:border-l lg:border-gray-200 lg:pl-6 overflow-y-auto">
              <div className="flex-1 p-4 space-y-6">
                {/* === Section 1: Summary === */}
                <div>
                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-200 divide-y divide-gray-200">
                    <div className="flex justify-between py-2 font-bold ">
                      <div>
                        <span className="block lg:hidden">
                          {t('app.transactionRefNo')}
                        </span>
                        <span className="hidden lg:block">
                          {t('app.transactionRefNo')}
                        </span>
                      </div>

                      <span
                        style={{
                          fontFamily: 'monospace',
                          color: '#16a34a',
                          fontSize: '16px',
                        }}
                      >
                        {dataRowDetail.order_id_ref}
                      </span>
                    </div>
                    <div className="flex justify-between py-2 font-bold">
                      <span> {t('app.pay')}</span>
                      <span>
                        {' '}
                        {dataRowDetail?.description?.replace(/\D/g, '')}{' '}
                        {t('app.xPeriods')}{' '}
                      </span>
                    </div>
                    <div className="flex justify-between pt-2 font-bold">
                      <span> {t('app.to')}</span>
                      <span>{dataRowDetail.sorgcode}</span>
                    </div>
                  </div>
                </div>

                {/* === Section 2: Totals === */}
                <div className="space-y-2">
                  <div className="flex justify-between font-bold">
                    <span>{t('app.totalAmount')}</span>
                    <span>{addCommas(dataRowDetail.total_amount)}</span>
                  </div>
                  <div className="flex justify-between text-red-600 font-bold">
                    <span>{t('app.discount')}(%)</span>
                    <span>{dataRowDetail.total_discount}</span>
                  </div>
                  <div className="flex justify-between font-bold">
                    <span>{t('app.vat')}(7%)</span>
                    <span>{dataRowDetail.total_vat}</span>
                  </div>
                </div>

                {/* === Section 3: Withholding Tax (WHT) === */}
                {dataRowDetail.wht_rate !== '0' && (
                  <div className="space-y-4 pt-6 border-t border-gray-200">
                    <h3 className="text-lg font-semibold text-gray-800">
                      {t('app.wht')}
                    </h3>

                    {/* WHT Rate Display */}
                    <div className="flex justify-between items-center">
                      <span className="ml-1 font-bold">{t('app.wht')}(%)</span>
                      <span className="mr-1 font-bold">{whtRate} %</span>
                    </div>

                    {/* WHT Info Box */}
                    <div className="p-3 text-xs bg-gray-50 rounded-lg border border-gray-200 space-y-2">
                      <div className="text-gray-600 text-[11px]">
                        {t('app.boiExemptInfo')}
                      </div>
                      <div className="text-yellow-700">
                        {t('app.whtContact')}
                      </div>
                      <div>
                        <Link
                          href="BOICloud.pdf"
                          underline="hover"
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{ fontSize: '0.8rem' }}
                        >
                          {t('app.downloadFile')}
                        </Link>
                      </div>
                    </div>

                    {/* WHT Upload Section */}
                    <div>
                      <div className="flex justify-between items-center mb-2">
                        <div>
                          <div className="text-sm ml-1 font-bold">
                            {t('app.attachWhtDoc')}
                          </div>
                          <div className="text-yellow-600 font-medium text-xs ml-1">
                            {t('app.fileSizeLimit')}
                          </div>
                        </div>
                        <label htmlFor="fileWHT">
                          <Button
                            variant="contained"
                            sx={{ color: 'white' }}
                            component="span"
                            size="small"
                          >
                            <UploadIcon />
                            {t('app.selectFile')}
                          </Button>
                        </label>
                        <input
                          type="file"
                          style={{ display: 'none' }}
                          id="fileWHT"
                          onChange={handleFileUploadWHT}
                          multiple
                          accept="image/*,application/pdf"
                        />
                      </div>

                      {/* WHT File List Box */}
                      <div className="border border-gray-300 rounded-lg mt-3 bg-white shadow-sm">
                        <div className="p-3 space-y-2 h-[160px] overflow-auto">
                          {importFileWHT?.length === 0 ? (
                            <div className="text-gray-400 text-sm text-center">
                              {t('app.noFileUploaded')}
                            </div>
                          ) : (
                            importFileWHT.map((file, index) => {
                              let icon;
                              if (file.type === 'application/pdf') {
                                icon = (
                                  <PictureAsPdfIcon sx={{ color: 'red' }} />
                                );
                              } else if (file.type.startsWith('image/')) {
                                icon = (
                                  <InsertPhotoIcon sx={{ color: '#398BF9' }} />
                                );
                              } else {
                                icon = <AttachFileIcon />;
                              }

                              return (
                                // ใช้ Style การแสดงรายการไฟล์แบบที่ refactor แล้ว
                                <div
                                  key={index}
                                  className="flex items-center bg-gray-50 hover:bg-gray-100 rounded-md px-3 py-2 transition"
                                >
                                  <div className="text-xl">{icon}</div>
                                  <div className="ml-3 flex flex-col text-sm overflow-hidden">
                                    <span className="font-medium text-gray-800 truncate max-w-[200px]">
                                      {file.name}
                                    </span>
                                    <span className="text-gray-500 text-xs">
                                      ({formatFileSize(file.size)})
                                    </span>
                                  </div>
                                  <button
                                    className="ml-auto text-red-500 hover:text-red-700"
                                    onClick={handleDeleteWHT(file)}
                                  >
                                    <CancelIcon />
                                  </button>
                                </div>
                              );
                            })
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* === Section 4: Payment Details (Final Totals & Form) === */}
                <div className="space-y-4 pt-6 border-t border-gray-200">
                  {/* Final Totals */}
                  <div className="space-y-2">
                    <div className="flex justify-between text-green-600 font-medium">
                      <span>{t('app.whtAmount')}</span>
                      <span>{addCommas(dataRowDetail.total_wht)}</span>
                    </div>
                    <div className="flex justify-between font-bold text-xl text-gray-900">
                      <span>{t('app.grandTotalThb')}</span>
                      <span>{addCommas(totalAmount)}</span>
                    </div>
                  </div>

                  {/* Form Inputs (ปรับให้ responsive) */}
                  <div className="space-y-3 pt-4">
                    {/* Fee */}
                    <div className="flex flex-col sm:flex-row justify-between sm:items-center">
                      <div className="w-full sm:w-1/3 mb-1 sm:mb-0 font-medium">
                        {t('app.fee')}
                      </div>
                      <div className="w-full sm:w-2/3">
                        <TextField
                          inputRef={feeRef}
                          placeholder={t('app.fee')}
                          sx={{ width: '100%' }}
                          size="small"
                          onChange={handleChangeFee}
                          value={fee}
                          id="outlined-basic"
                          variant="outlined"
                          type="number"
                          error={hasError && fee.trim() === ''}
                          helperText={
                            hasError && fee.trim() === '' ? t('app.enterFee') : ''
                          }
                        />
                      </div>
                    </div>

                    {/* Payment Amount */}
                    <div className="flex flex-col sm:flex-row justify-between sm:items-center">
                      <div className="w-full sm:w-1/3 mb-1 sm:mb-0 font-medium">
                        {t('app.paymentAmount')}
                      </div>
                      <div className="w-full sm:w-2/3">
                        <TextField
                          inputRef={paymentAmountRef}
                          placeholder="กรุณากรอกค่าชำระเงิน"
                          onChange={handleChangePaymentAmount}
                          value={paymentAmout}
                          id="outlined-basic"
                          sx={{ width: '100%' }}
                          variant="outlined"
                          size="small"
                          type="number"
                          error={hasError && paymentAmout.trim() === ''}
                          helperText={
                            hasError && paymentAmout.trim() === ''
                              ? t('app.enterPaymentAmount')
                              : ''
                          }
                        />
                      </div>
                    </div>

                    {/* Payment Bank */}
                    <div className="flex flex-col sm:flex-row justify-between sm:items-center">
                      <div className="w-full sm:w-1/3 mb-1 sm:mb-0 font-medium">
                        {t('app.paymentBank')}
                      </div>
                      <div className="w-full sm:w-2/3">
                        <Autocomplete
                          size="small"
                          options={bankData}
                          value={selectedBankOption}
                          isOptionEqualToValue={(option, value) =>
                            option?.bank_code === value?.bank_code
                          }
                          getOptionLabel={formatBankOptionLabel}
                          filterOptions={(options, { inputValue }) => {
                            const searchText = normalizeBankSearchText(inputValue);
                            if (!searchText) return options;

                            return options.filter((option) =>
                              normalizeBankSearchText(
                                `${option?.bank_fullname || ''}`,
                              ).includes(searchText),
                            );
                          }}
                          onChange={(event, newValue) => {
                            if (newValue) {
                              setSelectBank(newValue.bank_code);
                            } else {
                              setSelectBank('');
                            }
                          }}
                          renderOption={(props, option) => (
                            <li {...props} key={option?.bank_code}>
                              {option?.bank_fullname}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={t('app.paymentBank')}
                              size="small"
                              sx={{ width: '100%' }}
                              error={hasError && selectBank.length === 0}
                              helperText={
                                hasError && selectBank.length === 0
                                  ? t('app.paymentBank')
                                  : ''
                              }
                            />
                          )}
                        />
                      </div>
                    </div>

                    {/* Payment Date */}
                    <div className="flex flex-col sm:flex-row justify-between sm:items-center">
                      <div className="w-full sm:w-1/3 mb-1 sm:mb-0 font-medium">
                        {t('app.paymentDate')}
                      </div>
                      <div className="w-full sm:w-2/3">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            format="DD/MM/YYYY"
                            sx={{
                              height: '35px',
                              width: '100%',
                              backgroundColor: '#fff',
                            }}
                            slotProps={{ textField: { size: 'small' } }}
                            value={dateValue}
                            views={['year', 'month', 'day']}
                            onChange={(newValue) => {
                              setDateValue(newValue);
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                  </div>
                </div>

                {/* === Section 5: Proof of Payment (Slip Upload) === */}
                <div className="space-y-4 pt-6 border-t border-gray-200">
                  <div className="flex justify-between items-center mb-2">
                    <div>
                      <div className="text-sm ml-1 font-bold">
                        {t('app.attachProof')}
                      </div>
                      <div className="text-yellow-600 font-medium text-xs ml-1">
                        {t('app.fileSizeLimit')}
                      </div>
                    </div>
                    <label htmlFor="file">
                      <Button
                        variant="contained"
                        sx={{ color: 'white' }}
                        component="span"
                        size="small"
                        multiple
                      >
                        <UploadIcon />
                        {t('app.selectFile')}
                      </Button>
                    </label>
                    <input
                      type="file"
                      style={{ display: 'none' }}
                      id="file"
                      onChange={handleFileUpload}
                      multiple
                      accept="image/*,application/pdf"
                    />
                  </div>

                  {/* Payment File List Box */}
                  <div className="border border-gray-300 rounded-lg mt-3 bg-white shadow-sm">
                    <div className="p-3 space-y-2 h-[160px] overflow-auto">
                      {importFile?.length === 0 ? (
                        <div className="text-gray-400 text-sm text-center">
                          {t('app.noFileUploaded')}
                        </div>
                      ) : (
                        importFile.map((file, index) => {
                          let icon;
                          if (file.type === 'application/pdf') {
                            icon = <PictureAsPdfIcon sx={{ color: 'red' }} />;
                          } else if (file.type.startsWith('image/')) {
                            icon = (
                              <InsertPhotoIcon sx={{ color: '#398BF9' }} />
                            );
                          } else {
                            icon = <AttachFileIcon />;
                          }

                          return (
                            <div
                              key={index}
                              className="flex items-center bg-gray-50 hover:bg-gray-100 rounded-md px-3 py-2 transition"
                            >
                              <div className="text-xl">{icon}</div>
                              <div className="ml-3 flex flex-col text-sm overflow-hidden">
                                <span className="font-medium text-gray-800 truncate max-w-[200px]">
                                  {file.name}
                                </span>
                                <span className="text-gray-500 text-xs">
                                  ({formatFileSize(file.size)})
                                </span>
                              </div>
                              <button
                                className="ml-auto text-red-500 hover:text-red-700"
                                onClick={handleDelete(file)}
                              >
                                <CancelIcon />
                              </button>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>
              </div>{' '}
              {/* สิ้นสุด 'flex-1 p-4' wrapper */}
              {/* === Sticky Footer === */}
              <div className="sticky bottom-0 bg-white p-4 border-t border-gray-200">
                <Backdrop
                  open={snackBarLoading}
                  sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.drawer + 3,
                  }}
                >
                  <CircularProgress color="inherit" />
                  <span style={{ marginLeft: '1rem', fontSize: '1.2rem' }}>
                    {t('app.uploadSlip')}
                  </span>
                </Backdrop>

                {/* ปรับ layout ปุ่มให้ responsive */}
                <div className="flex flex-col sm:flex-row gap-2">
                  <Button
                    onClick={onClickUpload}
                    variant="contained"
                    sx={{ color: 'white' }}
                    fullWidth
                  >
                    {t('app.uploadSlip')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <NotiAlert
        open={openAlert}
        setOpen={setOpenAlert}
        title="อัพโหลดรายการสำเร็จ"
        value="success"
        onButtonClick={handleCloseDialogUpload}
      />
      <NotiAlert
        setValueAlert={setValueAlert}
        valueAlert={valueAlert}
        setErrorValue={setErrorValue}
        errorValue={errorValue}
        open={openFailAlert}
        setOpen={setOpenFailAlert}
        // title="กรุณาอัปโหลดหนังสือรับรองการหักภาษี ณ ที่จ่าย"
        value="cancel"
        onButtonClick={handleCloseDialogUpload}
      />
    </>
  );
}

export default WaitingUploadPayment;
